var e = Date.now || function () {
  return new Date().getTime();
};
export { e as default };